import { TagCombobox } from "components/TagCombobox/TagCombobox";
import { CHURNED } from "constants/TagType";
import { useToast } from "hooks/useToast";
import { useContext, useState } from "react";
import { useRoleBasedView } from "hooks/useRoleBasedView";
import { useCreateCompanyGroupTagMutation } from "store/apis/crm";
import { useAppDispatch } from "hooks/useAppDispatch";
import { openChurnDetailsModal } from "store/slices/churnDetailsModal";
import authContext from "../../jwt_context&axios/authContext";
import "../../static/styles/components/taskAssignee.css";
import Tag from "../design/Tag";

const CustomerTags = ({ tags }) => {
  if (!tags || tags?.length === 0) {
    return "-";
  }

  return (
    <div className="badgeGroup">
      {tags?.map((tag) => (
        <Tag key={tag.uuid} {...tag} />
      ))}
    </div>
  );
};

export default function Tags({ groupId, currentTags, tags, updateTags }) {
  const { alertToast } = useToast();
  const { authtoken } = useContext(authContext);
  const dispatch = useAppDispatch();
  const { isAdmin } = useRoleBasedView();

  const [isLoading, setLoading] = useState(false);
  const [createCompanyGroupTag, { isLoading: isCreating }] =
    useCreateCompanyGroupTagMutation();

  const onTagsChange = async (selectedTags) => {
    const addedTag = selectedTags.filter(
      ({ value }) => !currentTags?.some(({ uuid }) => uuid === value)
    )?.[0];

    const removedTag = currentTags?.filter(
      ({ uuid }) => !selectedTags?.some(({ value }) => uuid === value)
    )?.[0];

    const addedTagTitle = tags?.find(
      ({ uuid }) => uuid === addedTag?.value
    )?.title;

    if (removedTag) {
      setLoading(true);
      try {
        await updateTags({
          groupId: groupId,
          payLoad: { remove_tag_id: removedTag.uuid },
        });
      } catch (error) {
        alertToast({ message: error.data?.error?.message });
      }
      setLoading(false);
    }

    // CHURNED requires churn details before the tag itself is applied -- see the
    // comment on CHURNED in constants/TagType.ts.
    if (addedTag && addedTagTitle === CHURNED) {
      dispatch(openChurnDetailsModal(groupId));
      return;
    }

    if (!addedTag) {
      return;
    }

    setLoading(true);
    try {
      await updateTags({
        groupId: groupId,
        payLoad: { tag_id: addedTag.value },
      }).unwrap();
    } catch (error) {
      alertToast({ message: error.data?.error?.message });
    }
    setLoading(false);
  };

  const onTagCreate = async (title) => {
    try {
      const newTag = await createCompanyGroupTag({ title }).unwrap();
      setLoading(true);
      await updateTags({
        groupId,
        payLoad: { tag_id: newTag.uuid },
      }).unwrap();
    } catch (error) {
      alertToast({
        message: error?.data?.error?.message ?? "Something went wrong",
      });
    }
    setLoading(false);
  };

  if (!authtoken.is_service_user) {
    return <CustomerTags tags={currentTags} />;
  }

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <TagCombobox
        tags={tags}
        currentTags={currentTags}
        onTagsChange={onTagsChange}
        isLoading={isLoading || isCreating}
        {...(isAdmin ? { creatable: true, onCreateOption: onTagCreate } : {})}
      />
    </div>
  );
}
